import {
  EmptyStateNoResultIllustration,
  EmptyStateProps,
} from '@ardoq/status-ui';
import { OnButtonClick } from './types';
import { TertiaryButton, PrimaryButton } from '@ardoq/button';
import { t, type I18nLocale } from '@ardoq/i18n';

export type OnlyZeroValuesForBubbleSizeArgs = {
  editDataset: OnButtonClick;
  openBubbleChartSettings: OnButtonClick;
  i18nLocale: I18nLocale;
};

export const onlyZeroValuesForBubbleSize = ({
  editDataset,
  openBubbleChartSettings,
  i18nLocale,
}: OnlyZeroValuesForBubbleSizeArgs): EmptyStateProps => ({
  media: <EmptyStateNoResultIllustration />,
  title: t(
    i18nLocale,
    'tabview:graphViews.emptyStateLayout.onlyZeroValuesForBubbleSize.title',
    'The dataset has only 0 in the Bubble size field'
  ),
  description: t(
    i18nLocale,
    'tabview:graphViews.emptyStateLayout.onlyZeroValuesForBubbleSize.description',
    'Change your Bubble chart settings to show size 0 bubbles, select a different Bubble size field or edit your dataset.'
  ),
  children: (
    <>
      <TertiaryButton onClick={editDataset}>
        {t(
          i18nLocale,
          'tabview:graphViews.emptyStateLayout.onlyZeroValuesForBubbleSize.editDataset',
          'Edit dataset'
        )}
      </TertiaryButton>
      <PrimaryButton onClick={openBubbleChartSettings}>
        {t(
          i18nLocale,
          'tabview:graphViews.emptyStateLayout.onlyZeroValuesForBubbleSize.bubbleChartSettings',
          'Bubble chart settings'
        )}
      </PrimaryButton>
    </>
  ),
});
